import { motion } from "framer-motion";

export default function MaskedHeading({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1" }) {
    return (
        <Tag className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                    <motion.span
                        className={`block ${lineClassName}`}
                        initial={{ y: "115%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 0.95, delay: delay + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
}
